import { outletConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { apiConstants } from "../_constants/api.constants";

export const outletActions = {
  getAllOutlets,
};


//-- getAllOutlets
function getAllOutlets(apiName, userData) {
  return dispatch => {
    dispatch(commonAction.request(outletConstants.OUTLET_LIST_REQUEST, userData));
    commonService.withToken(apiName, userData).then(
      user => {

        dispatch(
          commonAction.success(outletConstants.OUTLET_LIST_SUCCESS, user.data)
        );
        if (user.success == false) {
          dispatch(
            commonAction.failure(outletConstants.OUTLET_LIST_ERROR, user.message)
          );
          dispatch(alertActions.error(user.message));
        }
      },
      error => {
        dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}